module.exports = {
  nonWriteoffList: '残高照会',
  writeoffList: '消込照会',
  selectHedgingTheInvoice: 'Please check and select the hedging',
  return: 'Return',
  query: 'Query',
  writeOffs: '消込',
  confirm: 'Confirm',
  hedgingWriteOffs: '相殺',
  actualReceiptAndPayment: '入出金実績',
  revenueAndExpenditureMethod: '収支方式',
  all: '全て',
  receivables: '売掛金',
  payables: '買掛金',
  feeType: '費用区分',
  domestic: '国内',
  international: '海外',
  writeOffMode: '消込モード',
  charges: '費用',
  invoice: '請求書',
  bill: '伝票',
  accountStatement: '取引明細',
  paymentRequest: '支払依頼',
  revenueAndExpenditureDate: '収支日付',
  writeOffSerialNumber: 'Clearance serial number',
  settleAccountsTo: 'SettlementObject',
  chargeRemark: 'Charge Remark',
  applyState: 'Apply State',
  applicationNo: 'Application No',
  businessNumber: 'JobNumber',
  theOppositeSideInvoiceNo: 'CounterpartInvoiceNo',
  consignationCompany: 'Consignation company',
  settlementAgent: 'Settlement agent',
  currency: ' 通貨',
  applicant: 'Applicant',
  businessType: '業務種別',
  dateOfApplication: 'Date of application',
  businessDate: 'JobDate',
  operation: ' 操作内容',
  sales: ' 売上',
  wroteOffOrNot: 'Clearance or not',
  businessReferenceNumber: '業務参照番号',
  businessStatus: '業務ステータス',
  separateNumber: 'HouseB/LNo',
  paymentNotificationNo: 'Payment notification No',
  applicationDepartment: 'Application Department',
  paymentPeriod: 'PaymentTimeLimit',
  amount: 'Amount',
  theAmountOfWriteOffs: 'Clearance Amount',
  approvalStatus: 'Approval status',
  businessAuditor: 'Business auditor',
  businessAuditDate: 'Business audit date',
  departmentAuditor: 'Department auditor',
  departmentAuditDate: 'Department audit date',
  officeAuditor: 'Office auditor',
  officeAuditDate: 'Office audit date',
  financialAuditor: 'Financial auditor',
  financialAuditDate: 'Financial audit date',
  financeVerifyDate: 'Financial verify date',
  verificationStatus: 'Verification status',
  remark: 'remark',
  totalAmountNtWrittenOff: 'Total amount not written off',
  methodOfPayment: 'Method of payment',
  claimState: 'Claim State',
  prePayment: 'Pre-receivedOrNot',
  lastTimeBalance: '前回残高',
  thisTimeWriteOff: '今回消込金額',
  thisTimeBalance: '今回残高',
  otherCurrency: '他通貨',
  paymentMethod: 'ReceivableMethod',
  bankReceiptStatus: '銀行入金状況',
  ourSideBank: '当社取引銀行',
  ourSideAccount: 'Our side account',
  proofNo: 'FinancialVoucherNo',
  usePaymentRecord: 'Use payment record',
  paymentAmount: '支払金額',
  receiptAmount: '受領金額',
  theOppositeSideCompany: '相手先会社名',
  theOppositeSideBank: '相手先銀行',
  theOppositeSideAccount: '相手先口座',
  exchangeGainsAndLosses: '為替差損益',
  financialCharges: '金融手数料',
  oddment: '端数処理',
  originalCurrencyExchangeDifference: 'Original Currency Exchange Difference',
  writeOffRemarks: '消込備考',
  paymentReceivedDate: '入金日',
  paymentDate: 'Payment date',
  confirmToWriteOff: '消込を確定',
  cancel: 'キャンセル',
  totalGainsAndLosses: 'Total gains and losses',
  date: 'Date',
  method: 'Method',
  use: 'Use',
  cancelUsed: 'Cancel used',
  record: 'record',
  chargeItem: 'ExpensesName',
  reconciliationStatus: 'Reconciliation status',
  type: 'Type',
  writeOffExchangeRate: 'Clearance Exchange rate',
  total: '合計',
  confirmedCharge: 'Confirmed charge',
  subTotal: 'Sub total',
  invoiceNo: 'インボイス番号',
  invoiceHeader: '請求書ヘッダー名',
  invoiceDate: '請求日',
  revenueAndExpenditureType: 'Revenue and expenditure type',
  billNo: '請求番号',
  accountStatementNo: 'Account Statement No',
  billType: 'Bill type',
  useReceiptRecord: '受領記録を使用',
  cancelUsedReceiptRecord: 'cancel used receipt record',
  cancelUsedPaymentRecord: 'cancel used payment record',
  mbl: 'MBL',
  itemNo: 'プロジェクト番号',
  bankReceiptNo: 'Bank receipt No',
  settlementCompany: 'Settlement Company',
  solicitationType: 'ResourceOfFreight',
  writeOffPerson: 'Clearance person',
  amountRange: '金額帯',
  writeOffDate: 'Clearance date',
  RecheckDate: 'ReviewDate',
  advanceMoneyOrNot: 'DisbursementOrNot',
  recheckOrNot: 'ReviewOrNot',
  proofOrNot: 'VoucherGenerateOrNot',
  proofDate: 'VoucherDate',
  paymentType: 'Payment type',
  prepaidOrNot: 'Prepaid or not',
  theAmountOfWrittenOff: 'The amount of written off',
  balance: 'Balance',
  actualReceiptAmount: 'Actual receipt amount',
  actualPaymentAmount: 'Actual payment amount',
  creator: '作成者',
  recheck: 'Re-check',
  invalid: 'Invalid',
  invoicingInformation: 'Invoicing information',
  unchecked: 'Unchecked',
  writeOffCurrency: 'Clearance Currency',
  chargeOriginalCurrency: 'Charge original currency',
  chargeOriginalAmount: 'Charge original amount',
  chargeOriginalExchangeRate: 'Charge original exchange rate',
  rmbAmount: 'RMB Amount',
  usdAmount: 'USD Amount',
  cancelRecheck: 'Cancel Recheck',
  editWriteOff: 'Edit Clearance',
  cancelWriteOff: 'Cancel Clearance',
  viewDetails: 'View details',
  exportExcel: 'Export Excel',
  proof: 'Proof',
  refreshRate: 'Refresh rate',
  refreshActualReceiptAndPaymentAmount: 'Refresh Actual Receipt and Payment Amount',
  writeOffType: 'Clearance type',
  vesselVoyage: 'Vessel/Voyage',
  containerSizeAmount: 'Container size/amount',
  monetaryEquivalent: 'Monetary equivalent',
  customerService: 'カスタマーサービス',
  totalWriteOffs: 'Total Clearance',
  totalEquivalent: 'Total equivalent',
  exportToExcel: 'Export to excel',
  exportPDF: 'Export PDF',
  print: 'Print',
  close: 'Close',
  dayOfCreditTerm: 'Credit Term',
  billPaymentNo: 'PaymentNoticeNo',
  totalCurrency: ' TotalInEachCurrency',
  rateBy: '消込為替レート',
  rateByInvoice: 'By Invoice Exchange Rate',
  rateByAverage: '平均為替レートによる',
  businessCreateDate: 'JobCreateDate',
  invoicingStatus: 'Invoicing Status',
  searchReqCondition: 'AtLeast1QueryCriteria',
  dateTo: '〜',
  lockCheckBoxDate: '2年以上前のデータを含む',
  queryLotsOfData: '2年以上前のデータ',
  writeOffDateNotEmpty: 'WriteOffDate Not Empty',
  unlockWriteOffDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  voucherNo: 'voucher No',
  voucherCreateDate: 'voucher CreateDate',
  chargeSettleAccountsTo: 'Charge 決算勘定',
  update: 'update',
  strip: 'strip',
  targetVoucherNo: 'Target Voucher No',
  voucherDate: 'Voucher Date2',
  sourceRateDiff: 'Exchange difference',
  warehouseNo: 'WarehouseNo',
  userDefinedField1: 'User Defined Field 1',
  userDefinedField2: 'User Defined Field 2',
  userDefinedField3: 'User Defined Field 3',
  havingInvoiceingNoOrNot: 'Having invoiceing No or not',
  selectActualReceiptAndPayment: 'Select Actual receipt and payment',
  noCurrencyRate: 'Unable to find the exchange rate of currency {0}, please maintain in time!',
  selectMethodOfPayment: 'Please select Method of payment.',
  selectOurSideBank: 'Please select Our side bank.',
  rateByCharge: 'ByChargeExchangeRate',
  preExchangeDifference: 'PreExchangeDifference',
  bankWaterNo: 'BankWaterNo',
  ReceivableSoldAmount: 'Receivable sold amount',
  PayableSoldAmount: 'Payable sold amount',
  ActualAmountReceivable: 'Actual amount receivable',
  ActualAmountPayable: 'Actual amount payable',
  ChargeOriginTotalAmount: 'Charge origin total amount',
  FinancialExpensesBeAllocated: 'Should financial expenses be allocated',
  FinanceExpensesAllocation: 'Allocation of financial expenses',
  ChargingDirection: 'Charging direction',
  SelectChargeItem: 'Please select charge item',
  SelectAccountObject: 'Please select account object',
  FinanceChargeShareJobTip: 'After checking the box, the financial expenses will be automatically allocated evenly to all transactions included in this write-off during clearance.',
  invoiceTitle: 'Invoice Title',
  writeoffMatchStatus: 'Match Status',
  matchStatusUnmatched: 'Unmatched',
  matchStatusAuto: 'Auto Written Off',
  matchStatusManual: 'Manual Write-off',
  matchStatusNoNeed: 'No Need Write-off',
  matchStatusReason: 'Reason for Status Change',
  writeoffSeqNoSource: 'Serial No. Source',
  sourceImport: 'Import',
  sourceSystem: 'System',
  modifyMatchStatus: 'Modify Match Status',
  modifyStatus: 'Modify Status',
  modifyReason: 'Reason',
  confirmModify: 'Confirm',
  modifySuccess: 'Successfully modified {0} records',
  lockedCannotModify: 'Locked, cannot modify',
  containsLockedStatus: 'Contains locked status, please select unmatched records',
  pleaseSelectUnmatched: 'Please select unmatched records',
  selectAtLeastOne: 'Please select at least one record'
}
